import React from 'react';
import {
    currencyFormatterToBRL,
    parseBRLToCents,
} from '@/helpers/currencyParser';
import * as S from './styles';

type CommonStepperProps = {
    value: number;
    onChange: (value: number) => void;
};

type NumberStepperProps = CommonStepperProps & {
    isError?: boolean;
    min?: number;
};

type PriceStepperProps = CommonStepperProps & {
    accent?: boolean;
};

export const NumberStepper = ({
    value,
    onChange,
    isError,
    min = 0,
}: NumberStepperProps) => (
    <S.StepperBox style={{ borderColor: isError ? 'red' : undefined }}>
        <S.StepperButton
            type="button"
            onClick={() => onChange(Math.max(min, value - 1))}
        >
            −
        </S.StepperButton>
        <S.StepperValue
            type="number"
            min={min}
            aria-invalid={isError}
            value={value}
            onChange={(e) => onChange(Math.max(0, Number(e.target.value) || 0))}
        />
        <S.StepperButton type="button" onClick={() => onChange(value + 1)}>
            +
        </S.StepperButton>
    </S.StepperBox>
);

export const PriceStepper = ({
    value,
    onChange,
    accent,
}: PriceStepperProps) => (
    <S.StepperBox>
        <S.StepperButton
            type="button"
            onClick={() => onChange(Math.max(0, value - 1))}
        >
            −
        </S.StepperButton>
        <S.PriceCell>
            <S.CurrencyPrefix>R$</S.CurrencyPrefix>
            <S.PriceInput
                $accent={accent}
                type="text"
                inputMode="decimal"
                placeholder="0,00"
                value={currencyFormatterToBRL(value).replace(/^[^\d-]+/, '')}
                onChange={(e) => onChange(parseBRLToCents(e.target.value))}
            />
        </S.PriceCell>
        <S.StepperButton type="button" onClick={() => onChange(value + 1)}>
            +
        </S.StepperButton>
    </S.StepperBox>
);

export const PriceInput = ({
    value,
    onChange,
    accent,
    isError,
}: PriceStepperProps & { isError?: boolean }) => {
    return (
        <S.PriceField style={{ borderColor: isError ? 'red' : undefined }}>
            <S.CurrencyPrefix>R$</S.CurrencyPrefix>
            <S.PriceFieldInput
                $accent={accent}
                aria-invalid={isError}
                type="text"
                inputMode="decimal"
                placeholder="0,00"
                value={currencyFormatterToBRL(value).replace(/^[^\d-]+/, '')}
                onChange={(e) => onChange(parseBRLToCents(e.target.value))}
            />
        </S.PriceField>
    );
};
